import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NotificationDataDispatcher } from './notification-data.dispatcher';
import { NotificationDataEffects } from './notification-data.effects';
import { FEATURE_NAME, reducer } from './notification-data.reducer';
import { NotificationDataService } from './notification-data.service';
import { NotificationDataStore } from './notification-data.store';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([NotificationDataEffects]),
    StoreModule.forFeature(FEATURE_NAME, reducer),
  ],
})
export class NotificationDataModule {
  static forRoot(): ModuleWithProviders<NotificationDataModule> {
    return {
      ngModule: NotificationDataModule,
      providers: [
        NotificationDataDispatcher,
        NotificationDataService,
        NotificationDataStore,
      ],
    };
  }
}
